import { Box, PseudoBox, Stack, Text, useColorMode } from '@chakra-ui/core';
import { useObserver } from 'mobx-react';
import React from 'react';
import { MdVolumeUp } from 'react-icons/md';
import { AnimateKeyframes } from 'react-simple-animate';

import { useStores } from '../hooks/useStores';
import QueueItem from './QueueItem';

function useStoreData() {
    const { store } = useStores();
    return useObserver(() => ({
        queue: store.playback.queueItemsSortedByOrder,
    }));
}

const PlaybackQueue = () => {
    const { queue } = useStoreData();

    const { colorMode } = useColorMode();
    const color = { light: 'gray.900', dark: 'gray.100' };

    return (
        <PseudoBox w="100%" color={color[colorMode]}>
            <Stack spacing={0}>
                {queue.length ? (
                    queue.map((item, index) => {
                        return (
                            <Box w="100%" key={`queueTrack-${item.track.id}`} position="relative">
                                <QueueItem item={item} current={index === 0} />
                                <Box top={'.5rem'} right={'30px'} alignSelf="flex-end" position="absolute" zIndex={1}>
                                    {index === 0 && (
                                        <AnimateKeyframes
                                            duration={0.8}
                                            direction="alternate"
                                            keyframes={['opacity: 0', 'opacity: 1']}
                                            iterationCount="infinite"
                                        >
                                            <Box as={MdVolumeUp} fontSize="20px" />
                                        </AnimateKeyframes>
                                    )}
                                </Box>
                            </Box>
                        );
                    })
                ) : (
                    <Text></Text>
                )}
            </Stack>
        </PseudoBox>
    );
};

export default PlaybackQueue;
